module.exports = __webpack_public_path__ + "static/media/home-section-1.23dc87d7.png";